import React from 'react';
import { Button } from 'app/components';
import { CALENDAR_LINK } from '../../../../constants/common';

const PromoBanner = () => {
  return (
    <>
      {/* Desktop Version */}
      <div className="hidden md:flex relative w-full min-h-[400px] bg-black text-white items-center justify-center gap-[15vw] mx-auto py-12">
        {/* Left Content */}
        <div className="flex flex-col gap-6 max-w-[600px]">
          {/* NEW Badge */}
          <div className="inline-flex items-center gap-2 bg-[#1A1A1A] rounded-full px-4 py-2 w-fit">
            <div className="flex items-center justify-center">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 0L9.79611 6.20389L16 8L9.79611 9.79611L8 16L6.20389 9.79611L0 8L6.20389 6.20389L8 0Z" fill="white"/>
              </svg>
            </div>
            <span className="text-white text-sm font-medium">NEW</span>
            <span className="text-gray-400 text-sm">Event ticketing platform</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-4xl lg:text-5xl font-bold leading-tight">
            Create Events and Sell Tickets{' '}
            <span className="text-yellow italic">Free</span> for the{' '}
            <span className="text-yellow italic">First 100 Organizers</span>
          </h1>

          {/* Subtext */}
          <p className="text-gray-400 text-base">
            Simple setup. Fast payouts. No hidden charges.
          </p>

          {/* Buttons */}
          <div className="flex flex-wrap gap-4">
            <Button
              onClick={() => window.open(CALENDAR_LINK, '_blank', 'noopener,noreferrer')}
            >
              Book a Call
            </Button>
            <Button 
              type="secondary"
              onClick={() => {
                window.open('/landing', '_blank', 'noopener,noreferrer');
              }}
            >
              List your event
            </Button>
          </div>
        </div>

        {/* Right Content - White Container with Image */}
        <div className="bg-white rounded-3xl p-1 flex items-center justify-center">
          <img 
            src="assets/images/promo_banner_desktop.png" 
            alt="Cheapest Fees" 
            className="w-64 h-64 object-contain"
          />
        </div>
      </div>

      {/* Mobile Version */}
      <div className="md:hidden flex flex-col w-full items-center justify-center p-4 ">

        <div className='bg-[#E5FFF6] rounded-t-xl'>
        {/* Attention Banner */}
        <div className="w-full max-w-[375px] bg-[#E5FFF6] rounded-t-xl px-4 py-3 flex items-center gap-2">
          <div className="flex-shrink-0">
            <img src="assets/images/Speaker.svg" alt="icon" className="w-6 h-6" />
          </div>
          <span className="text-[#009D64] text-xs font-medium">
            Attention- New Event ticketing platform in town!
          </span>
        </div>

        {/* Main Card */}
        <div className="w-full max-w-[375px] bg-black rounded-b-3xl overflow-hidden">
          <div className="p-6 flex flex-row gap-4">
            {/* Left Content */}
            <div className="flex flex-col gap-4 flex-1">
              {/* Heading */}
              <h2 className="text-xl font-bold text-white leading-tight">
                Create Events and Sell Tickets{' '}
                <span className="text-yellow italic">Free</span> for the{' '}
                <span className="text-yellow italic">First 100 Organizers</span>
              </h2>

              {/* Subtext */}
              <p className="text-gray-400 text-xs">
                Simple setup. Fast payouts. No hidden charges.
              </p>

              {/* Button */}
              <Button
                className="w-full"
                size="small"
                rounded={true}
                onClick={() => window.open(CALENDAR_LINK, '_blank', 'noopener,noreferrer')}
              >
                Book a Call
              </Button>

              {/* Secondary Button */}
              <Button 
                className="w-full"
                size="small"
                rounded={true}
                type="secondary"
                onClick={() => {
                  window.open('/landing', '_blank', 'noopener,noreferrer');
                }}
              >
                List your event
              </Button>
            </div>

            {/* Right Image */}
            <div className="flex items-center justify-center flex-shrink-0">
              <div className="w-28 h-28 flex items-center justify-center">
                <img 
                  src="assets/images/fees.png" 
                  alt="Cheapest Fees" 
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </>
  );
};

export default PromoBanner;
